import { useRef } from "react";
import { useTranslation } from 'react-i18next';
import { NavLink } from "react-router-dom";
import Tabs from "./Tabs";
const Sections = ({ tabNameForeign, from }) => {
    const { t } = useTranslation();
    const divRef = useRef(null);
    const dir = localStorage.getItem("dir");


    return (<>
        <section ref={divRef}>

            <center >
                <h1 style={{ lineHeight: '0', fontSize: '30px', fontWeight: 'bold' }}>{t('spare_parts_catelogue')}</h1>
            </center>

            <div className="container" data-animation-name="fadeInUpShorter" >
                <Tabs from={from} />
                <center style={{ direction: dir === 'rtl' ? 'ltr' : '', marginTop: "20px" }}><NavLink to={`/Spare-Parts/Catelog`}>{t('all_spare_parts_catelogue')} <i className="fas fa-chevron-right"></i></NavLink></center>
            </div>
        </section>
    </>)

}

export default Sections